import { render, staticRenderFns } from "./shopwindow.vue?vue&type=template&id=0c06f274&scoped=true"
import script from "./shopwindow.vue?vue&type=script&lang=js"
export * from "./shopwindow.vue?vue&type=script&lang=js"
import style0 from "./shopwindow.vue?vue&type=style&index=0&id=0c06f274&prod&lang=less&scoped=true"
import style1 from "./shopwindow.vue?vue&type=style&index=1&id=0c06f274&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c06f274",
  null
  
)

export default component.exports